import adPodsEnabled from "../rules/adpods";
import { useVideoAd } from "../presentation/VideoAdContext";

import { MuteButton } from "./MuteButton";
import { PlayPauseButton } from "./PlayPauseButton";

import "./SafeCountdown.css";

export default function SafeCountdown() {
  const { session, state } = useVideoAd();
  const initialTime = state.generalDuration;
  const useAdPods = session.adPodsAllowed();
  const isVideoState = state.phase === "video";

  return (
    <div className="avp-panel">
      <div className="avp-panel-top">
        { isVideoState ? (
          <div className="avp-panel-controls">
            <MuteButton onToggle={session.setVolume}/>
            <PlayPauseButton
              paused={state.videoPaused}
              onToggle={session.togglePlayback}
            />
          </div>
        ) : null }
        <span className="avp-panel-announce">Your game will resume after the following advertisement.</span>
        { useAdPods && adPodsEnabled() && isVideoState ? <div className="avp-panel-text">Ad {state.videoAdCount} of 3</div> : '' }
      </div>
      <div className="avp-panel-progress">
        <div className="avp-panel-progress-line" style={{ width: (initialTime ? 100/initialTime*(initialTime-state.generalTimeLeft) : 0) + '%' }}></div>
      </div>
    </div>
  );
}
